import { IDrives, IDrivesTable } from '@common/interfaces/LogbookAPI';

class Serializer {
  public static drivesToTable(i: IDrives): IDrivesTable {
    return {
      id: i.id ? `${i.id}|${i.isRidesharing}` : '—',
      signatureCode: i.signatureCode,
      driveTime: i.driveTime || '—',
      vehicle: `${i.vehicle?.agency?.shortName ? i.vehicle.agency.shortName : ''}|${
        i.vehicle.label
      }`,
      driverName: i.driver?.firstName ? `${i.driver?.firstName} ${i.driver?.lastName}` : '—',
      paxName: `${i.booking.firstName} ${i.booking.lastName}` || '—',
      paxN: i.nOfPassengers || '—',
      paxAgency: i.booking.agency?.toUpperCase() || '—',
      pickUp: i.pickupLocation || '—',
      dropOff: i.dropoffLocation || '—',
      km: JSON.stringify({ distanceNovacom: i.distanceNovacom, distance: i.distance }),
      time: i.duration ? i.duration : '—',
      transferType: i.transferTypeRepr,
      clientSignature:
        i.feedback?.clientSignature || i.isOfflineSignature
          ? `${i.feedback?.clientSignature}|${!!i.feedback?.clientSignature}|${
              i.isOfflineSignature
            }|${i.offlineSignature}`
          : '',
      pickUpTime: i?.pickupTime || '—',
    };
  }
}

export default Serializer;
